import React from 'react';
import { Box, Typography, Chip, Stack, CircularProgress } from '@mui/material';
import { useRecentSearches, RecentSearch } from '../hooks/useProductSearch';

interface RecentSearchesProps {
  onSearchSelect: (search: RecentSearch) => void;
  limit?: number;
}

export const RecentSearches: React.FC<RecentSearchesProps> = ({
  onSearchSelect,
  limit = 5,
}) => {
  const { data: recentSearches, isLoading } = useRecentSearches(limit);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!recentSearches || recentSearches.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 1,
          color: 'text.secondary',
          fontSize: '0.875rem',
          fontWeight: 500,
        }}
      >
        Recent Searches
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {recentSearches.map((search: RecentSearch) => (
          <Chip
            key={search.id}
            label={search.searchQuery || 'All products'}
            onClick={() => onSearchSelect(search)}
            size="small"
            variant="outlined"
            sx={{
              borderRadius: '16px',
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'white',
                borderColor: 'primary.main',
              },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};
